import { ContentState } from "draft-js"
import * as React from "react"

export interface LinkProps {
    contentState: ContentState
    entityKey: string
    children?: React.ReactNode
}

export const Link = (props: LinkProps) => {
    const data = props.contentState.getEntity(props.entityKey).getData()
    const { url } = data
    if (!url) {
        return <span>{props.children}</span>
    }
    return (
        <a href={url} title={url}>
            {props.children}
        </a>
    )
}
